import { fetchTraitNavItems } from 'Layout/Header/HeaderDrawer/TraitNavRequests'

export const Services = {
  traits: fetchTraitNavItems,
}
